import { SANDBOX } from '../data/constantes'

export default function Cargando() {
    return (
        <div className="flex justify-center">
            <div className={`bg-brand-bg rounded-lg mx-2.5 p-6 text-white ${SANDBOX ? 'watermark-bg-brand' : ''}`}>
                <div className="flex justify-center items-center w-full p-1.5 rounded-md">
                    <div
                        className="w-9 h-9 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin"
                        role="status"
                        aria-label="loading"
                    >
                        <span className="sr-only ">Cargando...</span>
                    </div>
                </div>
                <h1>Cargando...</h1>
            </div>
        </div>
    )
}
